export default __webpack_public_path__ + "static/media/asp-dot-net-wide.749a0d0e.png";